import AppSignal from '@appsignal/javascript'
import { plugin } from '@appsignal/plugin-window-events'

const appsignal = new AppSignal({
  key: import.meta.env.VITE_APPSIGNAL_KEY,
})

appsignal.use(plugin)

export { appsignal }
